import { apiMultipart } from '../api/client';
import type { KokoroSpeakResult } from './types';

export interface KokoroUploadPayload {
  wav: Blob;
  voiceId: string;
  text: string;
  turnId?: string | null;
  durationMs: number;
  sizeBytes: number;
  agentName: string;
}

export async function uploadKokoroWav(
  p: KokoroUploadPayload,
): Promise<KokoroSpeakResult> {
  const fd = new FormData();
  fd.append('file', p.wav, `${p.turnId ?? 'kokoro'}.wav`);
  fd.append('voiceId', p.voiceId);
  fd.append('text', p.text);
  if (p.turnId) fd.append('turnId', p.turnId);
  fd.append('durationMs', String(p.durationMs));
  fd.append('sizeBytes', String(p.sizeBytes));
  fd.append('agentName', p.agentName);
  return apiMultipart<KokoroSpeakResult>('/api/voice/kokoro-upload', fd);
}
